/**
 * Envio do formulário de contacto para a API serverless.
 *
 * Integração futura: substituir apenas o endpoint ou usar variável de ambiente
 * REACT_APP_CONTACT_API_URL se necessário apontar para outro host.
 */
export async function submitContactPayload(payload) {
  const base =
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL) ||
    '';
  const url = `${base.replace(/\/$/, '')}/api/contact`;

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { detail: text };
  }

  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || text || `HTTP ${res.status}`;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }

  return data || { ok: true };
}
